// Pak Gub — karakter flat-vector rapi, digambar 100% kode (gaya aset kota Jawsel: flat, tanpa outline, bayangan 1 nada di sisi kanan).
// Satuan: 1000 = tinggi badan; (0,0) = tengah telapak kaki. Rambut: pendek rapi, poni tersapu ke samping (sisi kanan penonton).
// gambarPakGub(ctx, t, { pose: idle|bingung|lambai|tunjuk|megafon, bicara, ekspresi: netral|senyum|kaget|datar|jengkel })
// jengkel = wajah "menyebalkan tapi datar" Kepala Otoritas: satu alis naik, kelopak setengah turun, senyum miring tipis
const W = {
  kulit: "#E3AA7B", kulitBayang: "#CC8F62",
  rambut: "#1A1A22", rambutBayang: "#0F0F15", rambutKilau: "#34344A",
  denim: "#3E60B3", denimBayang: "#2F4C92", denimTerang: "#5C7CCB", jahitan: "#D9B35B",
  kaos: "#F7F7FA", kaosBayang: "#DCDEE8",
  celana: "#1E2B5E", celanaBayang: "#151F47",
  sepatu: "#FFFFFF", sepatuBayang: "#E1E4EE", sol: "#CFD3DE",
  bingkai: "#F2F2F2", lensa: "rgba(190,215,255,0.2)", kilau: "rgba(255,255,255,0.55)",
  mata: "#1A1A22", iris: "#3B2A20", mulut: "#7D3B3B", gigi: "#FFFFFF", hp: "#111522", hpLayar: "#9DB4FF",
};
const BAYANG_X = 0; // bayangan: semua x > BAYANG_X (sisi kanan penonton) lebih gelap

function rr(ctx, x, y, w, h, r) { ctx.beginPath(); ctx.roundRect(x, y, w, h, r); }
function el(ctx, x, y, rx, ry) { ctx.beginPath(); ctx.ellipse(x, y, rx, ry, 0, 0, Math.PI * 2); }
/** isi path dengan warna + bayangan sisi kanan (x > batas) di-clip ke path */
function isi(ctx, path, warna, bayang, batas = 18) {
  path(); ctx.fillStyle = warna; ctx.fill();
  if (!bayang) return;
  ctx.save(); path(); ctx.clip(); ctx.fillStyle = bayang; ctx.fillRect(batas, -1200, 600, 1300); ctx.restore();
}

// ---------- lengan (2 segmen) + tangan berjari ----------
function jari(ctx, x, y, panjang, lebar, sudut) { ctx.save(); ctx.translate(x, y); ctx.rotate(sudut); rr(ctx, -lebar / 2, 0, lebar, panjang, lebar / 2); ctx.fill(); ctx.restore(); }
/** tangan di (x,y) pergelangan; sumbu +y = arah jari. jenis: santai | terbuka | tunjuk | genggam(benda) */
function tangan(ctx, x, y, sudut, jenis, benda) {
  ctx.save(); ctx.translate(x, y); ctx.rotate(sudut); ctx.fillStyle = W.kulit;
  if (jenis === "terbuka") {            // telapak terbuka menghadap atas, jari merenggang
    rr(ctx, -26, -6, 52, 46, 15); ctx.fill();
    for (let i = 0; i < 4; i++) jari(ctx, -20 + i * 13, 36, 38 - Math.abs(i - 1.3) * 5, 11.5, (i - 1.5) * 0.14);
    jari(ctx, -21, 4, 26, 11.5, 0.7);    // ibu jari (menempel tepi telapak)
  } else if (jenis === "tunjuk") {      // kepalan + telunjuk lurus
    rr(ctx, -22, -4, 44, 40, 14); ctx.fill();
    jari(ctx, 10, 30, 44, 12, 0);       // telunjuk
    for (let i = 0; i < 3; i++) jari(ctx, -14 + i * 11, 30, 12, 11, 0);
    jari(ctx, -18, 2, 20, 11, 0.9);
  } else if (jenis === "genggam") {     // kepalan menggenggam benda: telapak → benda → jari menutup di atas benda
    rr(ctx, -22, -4, 44, 42, 14); ctx.fill();
    if (benda) { ctx.save(); ctx.rotate(-sudut); benda(); ctx.restore(); }   // benda digambar tegak (koordinat dunia)
    ctx.fillStyle = W.kulit;
    for (let i = 0; i < 4; i++) jari(ctx, -17 + i * 11.5, 22, 16, 11, 0);
    jari(ctx, -19, 0, 22, 11, 1.05);    // ibu jari melingkar
  } else {                              // santai: jari sedikit menekuk
    rr(ctx, -24, -4, 48, 42, 15); ctx.fill();
    for (let i = 0; i < 4; i++) jari(ctx, -18 + i * 12, 32, 26 - Math.abs(i - 1.3) * 3, 11, 0.05);
    jari(ctx, -20, 2, 24, 11, 0.32);
  }
  ctx.restore();
}
function lengan(ctx, sx, sy, sisi, aBahu, aSiku, jenisTangan, benda) {
  const L1 = 124, L2 = 106;
  const ex = sx + Math.sin(aBahu) * sisi * L1, ey = sy + Math.cos(aBahu) * L1;
  const a2 = aBahu + aSiku, hx = ex + Math.sin(a2) * sisi * L2, hy = ey + Math.cos(a2) * L2;
  ctx.lineCap = "round"; ctx.lineJoin = "round";
  ctx.lineWidth = 50; ctx.strokeStyle = sisi > 0 ? W.denimBayang : W.denim;
  ctx.beginPath(); ctx.moveTo(sx, sy); ctx.lineTo(ex, ey); ctx.lineTo(hx, hy); ctx.stroke();
  ctx.strokeStyle = W.denimTerang;      // manset
  ctx.beginPath(); ctx.moveTo(hx - Math.sin(a2) * sisi * 28, hy - Math.cos(a2) * 28); ctx.lineTo(hx - Math.sin(a2) * sisi * 12, hy - Math.cos(a2) * 12); ctx.stroke();
  tangan(ctx, hx, hy, -a2 * sisi, jenisTangan, benda);
}

// ---------- kepala ----------
function kepala(ctx, t, o, napas) {
  const ekspresi = o.ekspresi || (o.pose === "bingung" || o.pose === "lari" ? "kaget" : "netral");
  const kedip = ((t * 1000 + 700) % 3600) < 120 ? 0.1 : 1;
  const buka = o.bicara ? 0.3 + 0.7 * Math.abs(Math.sin(t * 9.5 + 0.4)) : 0;
  ctx.save(); ctx.translate(0, -842 + napas * 0.4); ctx.rotate(Math.sin(t * 0.9) * 0.02); ctx.scale(0.92, 0.92);
  // leher
  isi(ctx, () => rr(ctx, -32, 50, 64, 100, 20), W.kulit, null);
  // telinga
  for (const s of [-1, 1]) { isi(ctx, () => el(ctx, s * 96, 10, 15, 22), W.kulit, null); }
  // wajah: dahi lebar, rahang tegas
  const wajah = () => { ctx.beginPath(); ctx.moveTo(0, -112); ctx.bezierCurveTo(70, -112, 100, -70, 98, -10); ctx.bezierCurveTo(98, 50, 76, 100, 0, 108); ctx.bezierCurveTo(-76, 100, -98, 50, -98, -10); ctx.bezierCurveTo(-100, -70, -70, -112, 0, -112); ctx.closePath(); };
  isi(ctx, wajah, W.kulit, null);
  // rambut pendek rapi: satu siluet utuh (mahkota + sisi sampai atas telinga), poni tersapu ke kanan
  isi(ctx, () => { ctx.beginPath(); ctx.moveTo(-100, 0); ctx.bezierCurveTo(-108, -96, -60, -140, 0, -138); ctx.bezierCurveTo(70, -140, 110, -100, 100, 0);
    ctx.lineTo(84, 0); ctx.bezierCurveTo(88, -40, 84, -62, 70, -60); ctx.bezierCurveTo(40, -46, 10, -58, -10, -76); ctx.bezierCurveTo(-40, -60, -70, -62, -82, -40);
    ctx.bezierCurveTo(-86, -30, -86, -14, -84, 0); ctx.closePath(); }, W.rambut, W.rambutBayang, 30);
  ctx.strokeStyle = W.rambutKilau; ctx.lineWidth = 6; ctx.lineCap = "round";
  ctx.beginPath(); ctx.moveTo(-40, -122); ctx.quadraticCurveTo(0, -130, 40, -118); ctx.stroke();
  ctx.beginPath(); ctx.moveTo(20, -100); ctx.quadraticCurveTo(50, -92, 72, -74); ctx.stroke();
  // alis tebal
  const jengkel = ekspresi === "jengkel";
  const alisY = ekspresi === "kaget" ? -52 : -42, lengkung = ekspresi === "datar" || jengkel ? 2 : -8;
  ctx.strokeStyle = W.rambut; ctx.lineWidth = 10; ctx.lineCap = "round";
  for (const s of [-1, 1]) {
    const naik = jengkel ? (s > 0 ? -9 : 3) : 0; // kanan terangkat, kiri sedikit turun → tatapan "serius, kok gitu?"
    ctx.beginPath(); ctx.moveTo(s * 62, alisY + 6 + naik); ctx.quadraticCurveTo(s * 40, alisY + lengkung + naik, s * 16, alisY + 2 + naik * 0.4); ctx.stroke();
  }
  // mata
  for (const s of [-1, 1]) {
    ctx.save(); ctx.translate(s * 40, -10); ctx.scale(1, kedip);
    ctx.fillStyle = "#fff"; el(ctx, 0, 0, 16, 12); ctx.fill();
    ctx.fillStyle = W.iris; el(ctx, 3, 1, 9, 9.5); ctx.fill();
    ctx.fillStyle = W.mata; el(ctx, 3, 1, 5, 5.5); ctx.fill();
    ctx.fillStyle = "#fff"; el(ctx, 6, -2.5, 2.4, 2.4); ctx.fill();
    ctx.strokeStyle = W.rambut; ctx.lineWidth = 3; ctx.beginPath(); ctx.ellipse(0, -1, 16, 12, 0, Math.PI * 1.1, Math.PI * 1.9); ctx.stroke();
    if (jengkel) { ctx.fillStyle = W.kulit; ctx.beginPath(); ctx.ellipse(0, -8 + (s > 0 ? 0 : 2), 17, 9, 0, 0, Math.PI * 2); ctx.fill(); } // kelopak setengah turun (malas/bosan)
    ctx.restore();
  }
  // kacamata bulat tipis
  ctx.strokeStyle = W.bingkai; ctx.lineWidth = 5;
  for (const s of [-1, 1]) {
    ctx.fillStyle = W.lensa; ctx.beginPath(); ctx.arc(s * 40, -8, 33, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
    ctx.fillStyle = W.kilau; ctx.beginPath(); ctx.ellipse(s * 40 - 10, -20, 8, 4.5, -0.6, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.moveTo(s * 73, -12); ctx.lineTo(s * 94, -16); ctx.stroke();
  }
  ctx.beginPath(); ctx.moveTo(-7, -12); ctx.quadraticCurveTo(0, -18, 7, -12); ctx.stroke();
  // hidung
  ctx.strokeStyle = W.kulitBayang; ctx.lineWidth = 6; ctx.lineCap = "round";
  ctx.beginPath(); ctx.moveTo(6, 2); ctx.quadraticCurveTo(18, 26, 0, 34); ctx.stroke();
  // mulut
  if (buka > 0.06) { ctx.fillStyle = W.mulut; el(ctx, 0, 60, 20 + 4 * buka, 5 + 16 * buka); ctx.fill(); ctx.fillStyle = W.gigi; rr(ctx, -14, 50 + 2 * buka, 28, 6 + 3 * buka, 3); ctx.fill(); }
  else if (ekspresi === "senyum") { ctx.strokeStyle = W.mulut; ctx.lineWidth = 6; ctx.beginPath(); ctx.moveTo(-24, 54); ctx.quadraticCurveTo(0, 76, 24, 54); ctx.stroke(); }
  else if (ekspresi === "kaget") { ctx.fillStyle = W.mulut; el(ctx, 0, 62, 10, 13); ctx.fill(); }
  else if (jengkel) { ctx.strokeStyle = W.mulut; ctx.lineWidth = 6; ctx.beginPath(); ctx.moveTo(-18, 61); ctx.quadraticCurveTo(0, 60, 18, 54); ctx.stroke(); } // senyum miring tipis
  else { ctx.strokeStyle = W.mulut; ctx.lineWidth = 6; ctx.beginPath(); ctx.moveTo(-18, 58); ctx.quadraticCurveTo(0, ekspresi === "datar" ? 58 : 66, 18, 58); ctx.stroke(); }
  ctx.restore();
}

/** gambar Pak Gub di ctx yang sudah di-translate ke titik kaki & di-scale (1 unit = 1/1000 tinggi) */
export function gambarPakGub(ctx, t, o = {}) {
  const pose = o.pose || "idle";
  const napas = Math.sin(t * 2.4) * 4, goyang = Math.sin(t * 1.3) * 0.012;
  ctx.save(); ctx.rotate(goyang + (pose === "lari" ? 0.1 : pose === "jalan" ? 0.03 : 0));
  if (pose === "lari" || pose === "jalan") ctx.translate(0, Math.abs(Math.sin(t * (pose === "lari" ? 11 : 6.5))) * -(pose === "lari" ? 26 : 10)); // lompatan langkah
  ctx.fillStyle = "rgba(0,0,0,0.3)"; el(ctx, 0, 8, 160, 24); ctx.fill();          // bayangan tanah
  // kaki + sepatu (berayun dari pinggul saat jalan/lari)
  const gerak = pose === "lari" ? { f: 11, a: 0.62, tekuk: 0.9 } : pose === "jalan" ? { f: 6.5, a: 0.38, tekuk: 0.5 } : null;
  for (const s of [-1, 1]) {
    const fase = gerak ? Math.sin(t * gerak.f + (s > 0 ? Math.PI : 0)) : 0;
    const sudut = gerak ? fase * gerak.a : 0, tekuk = gerak ? Math.max(0, -fase) * gerak.tekuk : 0;   // lutut menekuk saat kaki di belakang
    ctx.save(); ctx.translate(s * 44, -432); ctx.rotate(-sudut);
    isi(ctx, () => rr(ctx, -42, 0, 84, 210, 26), W.celana, W.celanaBayang, 8);                  // paha
    ctx.translate(0, 200); ctx.rotate(tekuk);
    isi(ctx, () => rr(ctx, -40, -10, 80, 204, 24), W.celana, W.celanaBayang, 8);                // betis
    ctx.translate(0, 194);
    isi(ctx, () => rr(ctx, -56, 12, 112, 28, 13), W.sol, null);
    isi(ctx, () => rr(ctx, -54, -16, 108, 36, 16), W.sepatu, W.sepatuBayang, 10);
    ctx.fillStyle = W.sepatuBayang; rr(ctx, -22, -16, 44, 9, 4); ctx.fill();
    ctx.restore();
  }
  ctx.fillStyle = W.celanaBayang; rr(ctx, -86, -440, 172, 38, 16); ctx.fill();   // pinggang
  // lengan jauh (kiri penonton) — di belakang badan
  ctx.save(); ctx.translate(0, napas);
  const bY = -682;
  const ayun = Math.sin(t * (pose === "lari" ? 11 : 6.5));
  const kiri = { idle: [0.26, 0.12, "santai"], bingung: [1.1, -1.0, "terbuka"], lambai: [0.22, 0.12, "santai"], tunjuk: [0.26, 0.1, "santai"], megafon: [0.26, 0.1, "santai"],
    lari: [0.2 - ayun * 0.9, -1.4, "santai"], jalan: [0.2 - ayun * 0.45, -0.5, "santai"] }[pose] || [0.26, 0.12, "santai"];
  lengan(ctx, -96, bY, -1, kiri[0], kiri[1], kiri[2]);
  // torso: bentuk meruncing (bahu membulat ±112 → pinggang ±84), kaos di tengah, jaket dua panel
  const torso = () => { ctx.beginPath(); ctx.moveTo(-84, -404); ctx.lineTo(-104, -640); ctx.quadraticCurveTo(-112, -722, -40, -722); ctx.lineTo(40, -722);
    ctx.quadraticCurveTo(112, -722, 104, -640); ctx.lineTo(84, -404); ctx.closePath(); };
  isi(ctx, torso, W.denim, W.denimBayang, 0);
  isi(ctx, () => { ctx.beginPath(); ctx.moveTo(-40, -404); ctx.lineTo(-46, -700); ctx.lineTo(46, -700); ctx.lineTo(40, -404); ctx.closePath(); }, W.kaos, W.kaosBayang, 14); // kaos
  for (const s of [-1, 1]) {
    isi(ctx, () => { ctx.beginPath(); ctx.moveTo(s * 24, -722); ctx.lineTo(s * 86, -722); ctx.lineTo(s * 48, -626); ctx.lineTo(s * 26, -664); ctx.closePath(); }, s > 0 ? W.denim : W.denimTerang, null); // lapel
    ctx.fillStyle = s > 0 ? W.denim : W.denimTerang; rr(ctx, s * 72 - 20, -596, 40, 40, 8); ctx.fill(); rr(ctx, s * 72 - 22, -604, 44, 12, 4); ctx.fill(); // saku dada
    ctx.fillStyle = W.jahitan; el(ctx, s * 72, -596, 3, 3); ctx.fill();
    ctx.strokeStyle = W.jahitan; ctx.lineWidth = 2.5; ctx.beginPath(); ctx.moveTo(s * 46, -690); ctx.lineTo(s * 40, -412); ctx.stroke(); // jahitan tepi
  }
  ctx.fillStyle = W.denimBayang; rr(ctx, -86, -436, 172, 34, 12); ctx.fill();   // ban pinggang jaket
  ctx.fillStyle = W.jahitan; for (let i = 0; i < 4; i++) { el(ctx, 36, -640 + i * 62, 4.5, 4.5); ctx.fill(); } // kancing
  // lengan dekat (kanan penonton) — di depan badan, bawa properti
  const hp = () => { ctx.save(); ctx.translate(4, 6); ctx.rotate(-0.22); ctx.fillStyle = W.hp; rr(ctx, -21, -58, 42, 96, 8); ctx.fill(); ctx.fillStyle = W.hpLayar; rr(ctx, -16, -52, 32, 82, 4); ctx.fill(); ctx.fillStyle = W.kilau; rr(ctx, -12, -48, 7, 44, 3.5); ctx.fill(); ctx.restore(); };
  const megafon = () => { ctx.save(); ctx.translate(2, 4); ctx.rotate(-0.85); ctx.fillStyle = "#C93A30"; rr(ctx, -34, -10, 46, 20, 8); ctx.fill(); ctx.fillStyle = "#E2473B";
    ctx.beginPath(); ctx.moveTo(10, -14); ctx.lineTo(72, -54); ctx.lineTo(72, 54); ctx.lineTo(10, 14); ctx.closePath(); ctx.fill(); ctx.fillStyle = "#F6F6FA"; el(ctx, 74, 0, 8, 56); ctx.fill(); ctx.restore(); };
  if (pose === "lari") lengan(ctx, 96, bY, 1, 0.2 + ayun * 0.9, -1.4, "santai");
  else if (pose === "jalan") lengan(ctx, 96, bY, 1, 0.2 + ayun * 0.45, -0.5, "santai");
  else if (pose === "bingung") lengan(ctx, 96, bY, 1, 1.1, -1.0, "terbuka");
  else if (pose === "lambai") lengan(ctx, 96, bY, 1, 2.55 + Math.sin(t * 6) * 0.15, -0.95 + Math.sin(t * 6) * 0.25, "terbuka");
  else if (pose === "tunjuk") lengan(ctx, 96, bY, 1, 2.0, -0.3, "tunjuk");
  else if (pose === "megafon") lengan(ctx, 96, bY, 1, 0.9, -2.3, "genggam", megafon);
  else lengan(ctx, 96, bY, 1, 0.5, -2.25, "genggam", hp);
  kepala(ctx, t, o, napas);
  ctx.restore();
  ctx.restore();
}
